<template>
    <div class="sales__conten">
        <NavSecond :banner="icon_stra"></NavSecond>
        <div class=" introduce__box">
<!--            <div class="over wrapper__w introduce__text">-->
<!--                <div class="fl ">-->
<!--                    <div class="base">-->
<!--                        <div class="title"><span>隐上简介</span></div>-->
<!--                        <div class="des">-->
<!--                            <p>隐上装饰前身是杭城首家提倡“工程管理”的源之通装饰工程管理有限公司。公司坚持专注高端装饰发展战略，秉承精益求精的工匠精神，实行专业的“3+1管家式服务”模式，携手众多行业内顶尖设计大师达成战略合作，以“客户满意度”为己任，矢志打造为高端业主提供专属私人定制服务的装饰企业。</p>-->

<!--                            <p>经过初创期、成长期、成熟期16年的发展，隐上团队凭借专业精湛的施工工艺及高效运营模式赢得广大客户的赞誉与信赖。</p>-->

<!--                            <p>2015年10月，为升级企业品牌形象，打造高端装饰“百年企业”理念，来自杭州建筑装饰行业的实力派人物胡发录先生创立了浙江隐上装饰设计工程有限公司，更有缘携手圣都装饰掌舵人颜伟阳先生助力隐上，共同推动隐上团队在高端装饰行业的稳步发展。2016年胡发录先生更进一步与杭城装饰工程实力专家高中华先生合力，共同以提供高端别墅装饰服务为己任，推动隐上装饰步入新一层台阶</p>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                    <div class="base__img&#45;&#45;int"><img :src="icon_int02"></div>-->
<!--                </div>-->
<!--                <div class="int__right fr">-->
<!--                    <img :src="icon_int01">-->
<!--                </div>-->
<!--            </div>-->
            <div class="wrapper__wpd introduce__text introduce__symbolic">
                <div class="int__right fl animate__animated  animate__fadeInUp">
                    <img :src="icon_af1">
                </div>
                <div class="fr">
                    <div class="base animate__animated  animate__fadeInUp" data-wow-delay=".2s" data-wow-duration="0.8s" style="margin-top: 200px;margin-bottom: 200px;">
                        <div class="title"><span>售后服务</span></div>
                        <div class="des" style="margin-top: 60px">
                            售后服务宗旨：坚持“客户第一，服务至上”的售后理念，采用“管家式服务”，以“专业、热情、周到、及时”为技术支持和售后服务的宗旨，从而增强对业主的售后维保工作，为业主做好后期服务保障工作！
                        </div>
                    </div>
                    <div class="base__img--int"><img :src="icon_af2"></div>
                </div>
                <div style="clear: both"></div>

            </div>
            <div class="wrapper__w  introduce__culture">
                <div class="bg" :style="{'background': 'url('+icon_af3+')', 'background-repeat': 'no-repeat',
                    'background-size': '100% 100%'}">
                    <div class="wow  animate__fadeInUp" data-wow-delay=".2s" data-wow-duration="0.8s">
                        <div class="title"><span>售后4s服务</span></div>
                        <div>
                            1、24h专业售后电话（13064771550），随时热情响应！<br>
                            2，专业化售后服务人员体系，细分工种提供更高效的服务！<br>
                            3、全套家装信息溯源档案备份，精准定位维保需求<br>
                            4、专业化售后检查，定期保养，贴心更周到！<br>
                        </div>
                    </div>
                </div>
            </div>
            <div class="wrapper__wpd introduce__text introduce__symbolic" style="padding-top: 0">
                <div class="int__right fl" style="width: 65%">
                    <img :src="icon_af4" style="width: 100%;margin-top: 10px;">
                </div>
                <div class="fr" style="width: 30%">
                    <div class="base wow  animate__fadeInUp" data-wow-delay=".2s" data-wow-duration="0.8s" style="margin-top: 300px;margin-bottom: 200px;">
                        <div class="title"><span>售后流程图</span></div>
                        <div class="des" style="margin-top: 60px">
                            为确保业主维保工作的及时响应，隐上成立了独立的售后网络体团队，规范的服务流程。
                        </div>
                    </div>
                </div>
                <div style="clear: both"></div>
            </div>


        </div>
        <div class="footer">
            <Footer></Footer>
        </div>
    </div>
</template>

<script>
    import icon_stra from '@/assets/img/gj01.png'
    import icon_af1 from '@/assets/img/af1.png'
    import icon_af2 from '@/assets/img/af2.png'
    import icon_af3 from '@/assets/img/af3.png'
    import icon_af4 from '@/assets/img/af4.png'

    import NavSecond from '@/components/NavSecond'
    import Footer from '@/layouts/Footer'


    export default {
        name: 'Test',
        data (){
            return {
                icon_stra, icon_af1, icon_af2, icon_af3, icon_af4
            }
        },
        components: {
            NavSecond,Footer
        },
        mounted() {
            this.$wow.init()
        },
    }
</script>
<style  lang="scss" scoped>
    .sales__conten{
        .introduce__box {
            padding-top: 70px;
            .title {
                font-size: 32px;
                font-weight: bold;
                color: #010101;
                margin: 40px 0;
                span {
                    position: relative;

                    &::after {
                        content: '';
                        display: block;
                        position: absolute;
                        left: 0;
                        bottom: -10px;
                        width: 32px;
                        height: 4px;
                        background: #F55E1B;
                    }
                }

            }
            .introduce__text{
                & > div{
                    width: 50%;
                }
                .base__img--int{
                    margin-top: 50px;
                    position: relative;
                    top: 50px;
                    img{
                        width: 92%;
                        display: block;
                    }
                }
                .base{
                    margin: 0 15%;
                }
                .des{
                    font-size: 16px;
                    font-weight: 400;
                    color: #010101;
                    line-height: 24px;
                    margin-top: 40px;
                    p{
                        margin-top: 20px;
                    }
                }
                .int__right{
                    img{
                        display: block;
                        width: 90%;
                        float: right;
                    }
                }
            }
            .introduce__culture{
                .bg {
                    margin-top: 120px;
                    margin-bottom: 100px;
                    height: 380px;
                    color: #fff;
                    font-size: 16px;
                    font-weight: 400;
                    line-height: 24px;
                    padding-left: 120px;

                    .title {
                        color: #fff;
                        padding-top: 90px;
                    }
                }
            }
            .introduce__symbolic{
                background: #fff;
                padding-top: 80px;
                .int__right{
                    img{
                        float: left;
                        margin-top: 30px;
                    }
                }
                .base__img--int{
                    img{
                        /*width: 82%;*/
                        float: right;
                    }
                }
            }

        }
        .footer{
            padding-top: 100px;
        }

    }

</style>
